<template>
  <div class="row postsLists">
    <PostCard :post="post" :index="i" v-for="(post, i) in posts" :key="post.id" class="mb-3" :postType="postType" />
  </div>
</template>

<script>
import PostCard from '~/components/Blog/PostCard';
export default {
  name: 'PostsList',
  props: {
    posts: {
      type: Array,
      required: true,
    },
    postType: {
      type: String,
      default: 'posts',
    },
    perPage: {
      type: Number,
      default: 10,
    },
    showPage: {
      type: Number,
      default: 1,
    },
  },
  components: {
    PostCard,
  },
  computed: {
    currentPage() {
      return this.showPage;
    },
  },
};
</script>

<style lang="scss"></style>
